// extracted by mini-css-extract-plugin
export var chevron = "_lx-3";
export var chevronRotated = "_lx-4";
export var image = "_lx-1";
export var imageContainer = "_lx-0";
export var shippingAddress = "_lx-2";